import axios from 'axios';
import { TTP_API_URL } from 'Config';

export const getQuestionScore = (token, instanceId, dimensionId, organizationId) => {
  const requestUrl = `${TTP_API_URL}/survey/result/question`;

  const params = {
    access_token: token,
    instance: instanceId || 0,
    organization: organizationId || 0,
    dimension: dimensionId || 0,
  };

  return axios.get(requestUrl, { params });
};
